import {fromJS as immutableFromJS} from 'immutable';

import checksumPath from 'rlink-router/checksumPath';
import {xhr} from 'rlink-utils/xhr';

import {BaseRepository} from './base';
import Metadata from './meta';

const CONTENT_AUTHORING_LOCALE = 'en';

export class HTTPRepository extends BaseRepository {
  constructor ({baseURL, contentMetaIndex: {translated, untranslated}, locale = null, prettyDump = true, useChecksumPaths, ...config}) {
    super(config);
    this.locale = locale;
    this.usePrettyDump = prettyDump;
    this.baseURL = baseURL;
    this.translatedContentChecksums = translated;
    this.untranslatedContentChecksums = untranslated;
    this.useChecksumPaths = useChecksumPaths;
  }

  async queuedFetchDataAndMetadata (path) {
    let isStructured = this.isStructuredDataPath(path);

    let adjustedPath = path;
    let baseURL = this.baseURL;

    let checksum;
    if (!(this.locale in this.translatedContentChecksums)) {
      throw new Error(`Localized content metadata is either not loaded or not available for locale ${this.locale}. (the content path requesting metadata was '${path}')`);
    }
    if (path in this.translatedContentChecksums[this.locale]) {
      if (this.locale !== CONTENT_AUTHORING_LOCALE) {
        baseURL = `${baseURL}/localized-content/${this.locale}`;
      }
      checksum = this.translatedContentChecksums[this.locale][path];
    } else if (path in this.untranslatedContentChecksums) {
      checksum = this.untranslatedContentChecksums[path];
    } else {
      console.warn(`Content checksum missing for path ${path}`);
      return [null, null];
    }
    if (this.useChecksumPaths) {
      adjustedPath = checksumPath(path, checksum);
    }

    let {response, _headers, status} = await xhr('GET', baseURL + adjustedPath, null,
      {responseType: isStructured ? 'json' : 'arraybuffer'});
    if (status === 404) {
      return [null, null];
    }

    return [
      isStructured ? immutableFromJS(response) : response,
      new Metadata({path}),
    ];
  }

  toString () {
    return `${this.constructor.name}("${this.baseURL}")`;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-repos/http.js